import { render, staticRenderFns } from "./DrivingBehavior2.vue?vue&type=template&id=64db65ac&"
import script from "./DrivingBehavior2.vue?vue&type=script&lang=js&"
export * from "./DrivingBehavior2.vue?vue&type=script&lang=js&"
import style0 from "./DrivingBehavior2.vue?vue&type=style&index=0&id=64db65ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports